import type { TWO_FACTOR_TYPE } from "@tastyworks/shared-utils/misc/constants"
import type HttpClient from "../../tastyworks/http"
import {
  parseItemsResponse,
  updateSingleResponse,
} from "../../tastyworks/response"
import { TWO_FACTOR_METHOD_DESER, TwoFactorMethod } from "../../tastyworks/user"

export class TwoFactorMethodService {
  private readonly twoFactorMethodClient: HttpClient
  private readonly activeMethodsClient: HttpClient

  constructor(userMeClient: HttpClient) {
    this.twoFactorMethodClient = userMeClient.nested("two-factor-methods")
    this.activeMethodsClient = this.twoFactorMethodClient.nested("active")
  }

  readonly showLatest = async () => {
    const helper = await this.twoFactorMethodClient.get("latest")
    const method = new TwoFactorMethod()
    return updateSingleResponse(helper, method, TWO_FACTOR_METHOD_DESER.update)
  }

  readonly listAllActive = async () => {
    const helper = await this.activeMethodsClient.get("all")
    return parseItemsResponse(helper, TWO_FACTOR_METHOD_DESER.toParser())
  }

  readonly setPrimary = async (type: TWO_FACTOR_TYPE) => {
    const helper = await this.twoFactorMethodClient.put("primary", { type })
    const method = new TwoFactorMethod()
    return updateSingleResponse(helper, method, TWO_FACTOR_METHOD_DESER.update)
  }
}
